var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitlinez(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3b6c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.433589, 226.845703)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 44.703125 -58.515625 L 44.703125 -48.828125 L 19.171875 -48.828125 L 19.171875 -33.34375 L 42.34375 -33.34375 L 42.34375 -23.78125 L 19.171875 -23.78125 L 19.171875 0 L 7.609375 0 L 7.609375 -58.515625 Z M 44.703125 -58.515625 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3b6c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.743976, 226.845703)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 19.171875 0 L 7.609375 0 L 7.609375 -58.515625 L 19.171875 -58.515625 Z M 19.171875 0 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3b6c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.561201, 226.845703)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 46.90625 -58.515625 L 46.90625 -48.78125 L 30.015625 -48.78125 L 30.015625 0 L 18.484375 0 L 18.484375 -48.78125 L 1.59375 -48.78125 L 1.59375 -58.515625 Z M 46.90625 -58.515625 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffa500",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.082018, 226.845703)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.734375 -58.515625 L 15.734375 -5.6875 L 43.90625 -5.6875 L 43.90625 0 L 8.84375 0 L 8.84375 -58.515625 Z M 15.734375 -58.515625 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffa500",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.47182, 226.845703)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.734375 0 L 8.84375 0 L 8.84375 -58.515625 L 15.734375 -58.515625 Z M 15.734375 0 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffa500",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.087636, 226.845703)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.5625 0 L 8.84375 0 L 8.84375 -58.515625 L 17.296875 -58.515625 L 45.828125 -13.8125 L 46.828125 -13.96875 L 46.828125 -58.515625 L 53.515625 -58.515625 L 53.515625 0 L 46.3125 0 L 16.5625 -47.828125 L 15.5625 -47.671875 Z M 15.5625 0 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffa500",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(266.487722, 226.845703)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.734375 -27.578125 L 15.734375 -5.6875 L 45.546875 -5.6875 L 45.546875 0 L 8.84375 0 L 8.84375 -58.515625 L 44.90625 -58.515625 L 44.90625 -52.828125 L 15.734375 -52.828125 L 15.734375 -33.265625 L 41.46875 -33.265625 L 41.46875 -27.578125 Z M 15.734375 -27.578125 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffa500",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.919477, 226.845703)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 43.3125 0 L 3.15625 0 L 3.15625 -6.203125 L 35.296875 -51.984375 L 35.015625 -52.828125 L 4.359375 -52.828125 L 4.359375 -58.515625 L 43.0625 -58.515625 L 43.0625 -52.34375 L 10.96875 -6.53125 L 11.203125 -5.6875 L 43.3125 -5.6875 Z M 43.3125 0 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitlinez);
export default __webpack_public_path__ + "static/media/FITLINEZ.e5121b430debbe5da769ceb9e5f1f929.svg";
export { ForwardRef as ReactComponent };